import { useSelector } from 'react-redux';

export const EnumFeatures = {
  AFIP_INVOICES: 'AFIP_INVOICES',
  SHOPPING_CART: 'SHOPPING_CART',
  AI_SALES_ASSISTANT: 'AI_SALES_ASSISTANT',
  AI_ASSISTANT: 'AI_ASSISTANT'
};

export const isFeatureEnabledForUser = (userProfile, feature) => {
  let settings = userProfile?.settings;
  if (typeof settings === 'string') {
    try {
      settings = JSON.parse(settings);
    } catch (e) {
      return false;
    }
  }

  const features = settings?.features || [];

  if (Array.isArray(feature)) {
    return feature.some((f) => features.includes(f));
  }
  return features.includes(feature);
};

export const useIsFeatureEnabled = (feature) => {
  const userProfile = useSelector((state) => state.userProfileData);
  return isFeatureEnabledForUser(userProfile, feature);
};
